import { PremierServiceProductTypeDTO } from "../DTO/premierServiceProductTypeDTO";

export class PremierServiceProductType{
    public id!: string;
    public name!: string;

    public static mapFromDTO(param:PremierServiceProductTypeDTO):PremierServiceProductType{
        if(!param) throw new Error("parameter is null");
        let obj = new PremierServiceProductType();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:PremierServiceProductType):PremierServiceProductTypeDTO{
        if(!param) throw new Error("parameter is null");
        let dto = new PremierServiceProductTypeDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
        }
        catch(e)
        {
            console.log(e);
        }
        return dto;
    }
}